export default {
  zh: {
    redirect: '正在跳转至',
    wait: '，请稍后...',
    paypal: 'Paypal',
    'alipay_global': '支付宝111',
    'paymentwall': 'Paymentwall',
    airwallex: '支付宝'
  },
  en: {
    redirect: 'Redirecting to ',
    wait: ', please wait',
    paypal: 'Paypal',
    'alipay_global': 'Alipay',
    'paymentwall': 'Paymentwall',
    airwallex: 'Alipay'
  }
}



// WEBPACK FOOTER //
// ./src/components/topup/payRedirect/lang.js